import homePage from "@/views/index";

import report_flow from "@/views/report_flow";
import report_flow_all from "@/views/report_flow_all";
import report_order from "@/views/report_order";
import report_customer from "@/views/report_customer";
import report_service from "@/views/report_service";

import test from "@/views/test";
import config_pos from "@/views/config_pos";
import config_pay from "@/views/config_pay";
import config_agent from "@/views/config_agent";
import config_employee from "../views/config_employee.vue";
import config_product from "../views/config_product.vue";
import modify_product from "../views/modify_product.vue";
import employee_detail from "../views/employee_detail.vue";
import cashier_mgr from "../views/cashier_mgr.vue";
import apply_cashier from "../views/apply_cashier.vue";
import partner_mgr from "../views/partner_mgr.vue";
import posList from "../views/posList.vue";
import pos_detail from "../views/pos_detail.vue";
import message_report from "@/views/message_report";
import message_event from "@/views/message_event";
import message_task from "@/views/message_task";
import orderlist from "@/views/orderlist";
import orderlist_user from "@/views/orderlist_user";
import userlist from "@/views/userlist";

import token_check from "@/views/token_check";

import apply_maintanance from "@/views/apply_maintanance";
import pos_mgr from "@/views/pos_mgr";
import product_mgr from "@/views/product_mgr";
import asset_mgr from "@/views/asset_mgr";
import ld_charge from "@/views/ld_charge";
import ld_deposit from "@/views/ld_deposit";
import ld_deposit_apply_mgr from "@/views/ld_deposit_apply_mgr";
import refund_apply_mgr from "@/views/refund_apply_mgr";
import invoice_apply_mgr from "@/views/invoice_apply_mgr";

import operation_mgr from "@/views/operation_mgr";
import system_message from "@/views/system_message";
import partner_detail from "../views/partner_detail.vue";
import pos_approval from "../views/pos_approval.vue";
import employee_approval from "../views/employee_approval.vue";
import add_partner from "../views/add_partner.vue";
import add_product from "../views/add_product.vue";
import mod_p2p_product from "../views/mod_p2p_product.vue";
import approve_merchant from "../views/approve_merchant.vue";

import plate_msg from "../views/plate_msg.vue";
import material_query from "../views/material_query.vue";
import material_sendMsg from "../views/material_sendMsg.vue";
import material_declarationList from "../views/material_declarationList.vue";
import material_collection from "../views/material_collection.vue";
import monitor_screen from "../views/monitor_screen.vue";
import pos_monitor_handler from "../views/pos_monitor_handler.vue";
import customer_care_handler from "../views/customer_care_handler.vue";
import comments_reply from "../views/comments_reply.vue";
import coupon_activity_mgr from "../views/coupon/coupon_activity_mgr.vue";
import coupon_activity_list from "../views/coupon/coupon_activity_list.vue";
import coupon_list from "../views/coupon/coupon_list.vue";
import gen_qr_code from "../views/gen_qr_code.vue";

const routes = [
  {
    path: "/",
    name: "homePage",
    component: homePage,
  } /*
  {
    path: '/genQRCode',
    name: 'genQRCode',
    component: genQRCode
  },//*/,
  {
    path: "/material_collection",
    name: "material_collection",
    component: material_collection,

  },
  //通过mqtt管理员发布信息
  {
    path: "/material_sendMsg",
    name: "material_sendMsg",
    component: material_sendMsg,
  },
  {
    path: "/material_declarationList",
    name: "material_declarationList",
    component: material_declarationList,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/material_query",
    name: "material_query",
    component: material_query,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/report_flow",
    name: "report_flow",
    component: report_flow,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/report_flow_all",
    name: "report_flow_all",
    component: report_flow_all,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/report_customer",
    name: "report_customer",
    component: report_customer,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/report_service",
    name: "report_service",
    component: report_service,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/report_order",
    name: "report_order",
    component: report_order,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/config_pos",
    name: "config_pos",
    component: config_pos,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/config_pay",
    name: "config_pay",
    component: config_pay,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/config_agent",
    name: "config_agent",
    component: config_agent,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  // 配置管理-雇员管理
  {
    path: "/config_employee",
    name: "config_employee",
    component: config_employee,
    meta: {
      needLogin: true,
    },
  },
  // 雇员详情
  {
    path: "/employee_detail",
    name: "employee_detail",
    component: employee_detail,
    meta: {
      needLogin: true,
    },
  },
  // 配置管理-产品管理
  {
    path: "/config_product",
    name: "config_product",
    component: config_product,
    meta: {
      needLogin: true,
    },
  },
  // 产品管理-产品修改
  {
    path: "/modify_product",
    name: "modify_product",
    component: modify_product,
    meta: {
      needLogin: true,
    },
  },
  // 收银管理
  {
    path: "/cashier_mgr",
    name: "cashier_mgr",
    component: cashier_mgr,
    meta: {
      needLogin: true,
    },
  },
  // 收银账户申请
  {
    path: "/apply_cashier",
    name: "apply_cashier",
    component: apply_cashier,
    meta: {
      needLogin: true,
    },
  },
  // 微信商户账户审批
  {
    path: "/approve_merchant",
    name: "approve_merchant",
    component: approve_merchant,
    meta: {
      needLogin: true,
    },
  },
  // 商家管理
  {
    path: "/partner_mgr",
    name: "partner_mgr",
    component: partner_mgr,
    meta: {
      needLogin: true,
    },
  },
  // 商家详情
  {
    path: "/partner_detail",
    name: "partner_detail",
    component: partner_detail,
    meta: {
      needLogin: true,
    },
  },
  // 网点管理
  {
    path: "/posList",
    name: "posList",
    component: posList,
    meta: {
      needLogin: true,
    },
  },
  {
    path: "/pos_detail",
    name: "pos_detail",
    component: pos_detail,
    meat: {
      needLogin: true,
    },
  },
  {
    path: "/message_task",
    name: "message_task",
    component: message_task,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/token_check",
    name: "token_check",
    component: token_check,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/message_event",
    name: "message_event",
    component: message_event,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/message_report",
    name: "message_report",
    component: message_report,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/orderlist",
    name: "orderlist",
    component: orderlist,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/orderlist_user",
    name: "orderlist_user",
    component: orderlist_user,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },

  {
    path: "/userlist",
    name: "userlist",
    component: userlist,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/test",
    name: "test",
    component: test,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/apply_maintanance",
    name: "apply_maintanance",
    component: apply_maintanance,
  },
  {
    path: "/pos_mgr",
    name: "pos_mgr",
    component: pos_mgr,
    meta: {
      needLogin: false, //需要加校检判断的路由
    },
  },
  {
    path: "/product_mgr",
    name: "product_mgr",
    component: product_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/asset_mgr",
    name: "asset_mgr",
    component: asset_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/ld_charge",
    name: "ld_charge",
    component: ld_charge,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/ld_deposit",
    name: "ld_deposit",
    component: ld_deposit,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/ld_deposit_apply_mgr",
    name: "ld_deposit_apply_mgr",
    component: ld_deposit_apply_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/refund_apply_mgr",
    name: "refund_apply_mgr",
    component: refund_apply_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/invoice_apply_mgr",
    name: "invoice_apply_mgr",
    component: invoice_apply_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/operation_mgr",
    name: "operation_mgr",
    component: operation_mgr,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  {
    path: "/system_message",
    name: "system_message",
    component: system_message,
    meta: {
      needLogin: true, //需要加校检判断的路由
    },
  },
  // 商家审批
  {
    path: "/pos_approval",
    name: "pos_approval,",
    component: pos_approval,
    meta: {
      needLogin: true,
    },
  },
  // 雇员审批
  {
    path: "/employee_approval",
    name: "employee_approval",
    component: employee_approval,
    meta: {
      needLogin: true,
    },
  },
  // 增加商户
  {
    path: "/add_partner",
    name: "add_partner",
    component: add_partner,
    meta: {
      needLogin: true,
    },
  },
  //   新增产品
  {
    path: "/add_product",
    name: "add_product",
    component: add_product,
    meta: {
      needLogin: true,
    },
  },
  //   产品自定义配置
  {
    path: "/mod_p2p_product",
    name: "mod_p2p_product",
    component: mod_p2p_product,
    meta: {
      needLogin: true,
    },
  },
  //   发送消息
  {
    path: "/plate_msg",
    name: "plate_msg",
    component: plate_msg,
    meta: {
      needLogin: true,
    },
  },
  // 监控大屏
  {
    path: "/monitor_screen",
    name: "monitor_screen",
    component: monitor_screen,
    meta: {
      needLogin: true,
    }
  },
  // 监控大屏门店操作页面
  {
    path: "/pos_monitor_handler",
    name: "pos_monitor_handler",
    component: pos_monitor_handler,
    meta: {
      needLogin: true
    }
  },
  // 监控大屏门店操作页面
  {
    path: "/customer_care_handler",
    name: "customer_care_handler",
    component: customer_care_handler,
    meta: {
      needLogin: true
    }
  },
  {
    path: "/comments_reply",
    name: "comments_reply",
    component: comments_reply,
    meta: {
      needLogin: true
    }
  },
  // 配置优惠券活动
  {
    path: "/coupon_activity_mgr",
    name: "coupon_activity_mgr",
    component: coupon_activity_mgr,
    meta: {
      needLogin: true
    }
  },
  // 查询优惠券活动列表
  {
    path: "/coupon_activity_list",
    name: "coupon_activity_list",
    component: coupon_activity_list,
    meta: {
      needLogin: true
    }
  },
  // 优惠券列表
  {
    path: "/coupon_list",
    name: "coupon_list",
    component: coupon_list,
    meta: {
      needLogin: true
    }
  },
  // 生成二维码
  {
    path: "/gen_qr_code",
    name: "gen_qr_code",
    component: gen_qr_code,
    meta: {
      needLogin: true
    }
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js